import React, {useState, useEffect} from 'react';
import headerBanner from './../images/header-banner.png';

import {Link} from 'react-router-dom';
import {Modal, Toast, Button, WhiteSpace, WingBlank, ActivityIndicator} from 'antd-mobile';

import dal from '../data/DAL';
import User from "../models/User";
import AppEvents from '../AppEvents'

import {isSafariIos, isHomeScreenApp} from "../util/util";
import AppConfig from '../appConfig'

const alert = Modal.alert;
const prompt = Modal.prompt;

let debug = require('debug')('APP:Home')


/**
 * 主页面
 */
const Home: React.FC = (props: any) => {

    const [user, setUser] = useState(new User())
    const [modalVisible, setModalVisible] = useState(false)
    const [username, setUsername] = useState('')
    const [animating, setAnimation] = useState(false)
    let isDataLoaded = false

    useEffect(() => {
        debug('Home useEffect')

        if (!isSafariIos()) {
            Toast.fail('请使用Safari浏览器', 1000)
            return
        }
        setAnimation(true)
        dal.loadStorage()
        initUser()
        addVisibilityChange()
    }, [])

    const getUsernameFromUrl = () => {
        let splits = window.location.search.match(RegExp('username=(.*)'))
        if (splits !== null) {
            return splits[1]
        }
        return null
    }

    const getFromUsernameFromUrl = () => {
        let splits = window.location.search.match(RegExp('fromUsername=(.*)'))
        if (splits !== null) {
            return splits[1]
        }
        return null
    }

    const initUser = () => {
        debug('initUser, dal.isDataLoaded=' + dal.isDataLoaded)

        let fromUsername = getFromUsernameFromUrl()
        if (fromUsername != null) {
            replaceUrlWithUsername(fromUsername)
            refreshDataAndUpdateUI(fromUsername)
            return
        }

        if (isHomeScreenApp()) {
            let username = getUsernameFromUrl()
            if (username != null) {
                refreshDataAndUpdateUI(username)
                return
            }
        }

        if (dal.isDataLoaded) {
            let username = dal.state.user.username
            replaceUrlWithUsername(username)
            refreshDataAndUpdateUI(username)
            return
        }

        getUsernameFromIframe().then(username => {
            if (username !== '') {
                replaceUrlWithUsername(username)
                refreshDataAndUpdateUI(username)
            } else {
                debug('register new user')
                registerNewUserAndRedirect()
            }
        })
    }


    const registerNewUserAndRedirect = () => {
        Toast.success('初始化新用户')
        setAnimation(false)
        dal.autoRegister().then(() => {
            window.location.href = AppConfig.iframeSaveUserUrl + '?username=' + dal.state.user.username + '&target=' + window.location.href
        }).catch((msg => {
            Toast.fail("注册用户失败：" + msg)
        }))
    }

    const refreshDataAndUpdateUI = (username: string) => {
        debug("refreshDataAndUpdateUI, dal.isUserRegistered=" + dal.isUserRegistered)
        if (!dal.isUserRegistered) {
            dal.autoRegister(username).then(() => {
                //Toast.success('初始化用户成功')
                dal.syncServerUserData().then(rsp => {
                    mapState()
                })
            }).catch((msg => {
                Toast.fail("初始化用户失败" + msg)
            }))
        } else {
            dal.syncServerUserData().then(rsp => {
                mapState()
            })
        }
    }

    const replaceUrlWithUsername = (username: string) => {
        props.history.replace('home?username=' + username)
    }

    const getUsernameFromIframe = async () => {
        let iframe: any = document.getElementById('iframe');
        iframe.src = AppConfig.iframeResotreUserUrl
        return new Promise<string>((resolve, reject) => {
            let dataResolved = false
            window.addEventListener("message", function (event) {
                if (event.origin === AppConfig.iframeOrigin) {
                    debug(`Get data from iframe, dataResolved: ${dataResolved}, username: ${event.data}`, event)
                    let username = event.data
                    if (!dataResolved) {
                        debug('IFrame获取用户名成功: ', username)
                        dataResolved = true
                        resolve(username)
                    }
                }
            }, false)
            iframe.onload = function () {
                debug('IFrame加载成功')
            };
            setTimeout(() => {
                debug('TIMEOUT, Get data from iframe, dataResolved:', dataResolved)
                if (!dataResolved) {
                    debug('IFrame获取用户名失败')
                    dataResolved = true
                    resolve('')
                }
            }, AppConfig.iframeLoadTimeout)
        })
    }

    const mapState = () => {
        //debug('mapState: ', dal.state.user)
        setAnimation(false)
        let u = new User();
        // FIXME
        Object.assign(u, dal.state.user);
        setUser(u);
        setUsername(u.username);
        setTimeOutSetVipLeftSeconds()
    };

    /**
     * 监听是否退到后台
     */
    const addVisibilityChange = () => {
        let start = 0;
        let end = 0;
        let s = 0;
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                start = new Date().getTime()
            } else if (document.visibilityState === 'visible') {
                end = new Date().getTime();
                s = Math.floor((end - start) / 1000);
                let user = dal.state.user;
                if (user.vipLeftSeconds > s) {
                    user.vipLeftSeconds = user.vipLeftSeconds - s;
                } else {
                    user.vipLeftSeconds = 0;
                }
                let newUser = new User();
                Object.assign(newUser, user);
                setUser(newUser);
                setTimeOutSetVipLeftSeconds();
            }
        })
    }

    const setTimeOutSetVipLeftSeconds = () => {
        setTimeout(() => {
            debug('定时器启动')
            let user = dal.state.user;
            if (user.vipLeftSeconds > 60) {
                user.vipLeftSeconds = user.vipLeftSeconds - 60;
                let newUser = new User();
                Object.assign(newUser, user)
                setUser(newUser)
            }
        }, 60 * 1000)
    }

    /**
     * 恢复会员对话框
     */
    const promptRecoverMemberDialog = () => {
        prompt('会员恢复', '请输入您的“会员恢复码”或微信订单的“商户单号”或PayPal中的“账单号“或云闪付中的“商户订单号”，恢复会员，恢复成功后，需重新下载并安装描述文件。', [
            {text: '取消'},
            {text: '立即恢复', onPress: value => recoverMember(value)},
        ], 'default', '');
    };

    /**
     * 恢复会员
     * @param {string} paymentId 订单号
     */
    const recoverMember = (paymentId: string) => {
        //console.log(`输入的内容:${paymentId}`)
        // 测试恢复账号的支付id

        //let testPaymentId = 'd48bffc211f9e37d9bcabda1fc58f9f0';   windows
        // 339586ef9a12819119cb02091fa4a2c0             ios
        if (!paymentId) {
            Toast.fail('请输入微信订单的"商户单号"或支付宝订单的"商家订单号"或PayPal中的“账单号“或云闪付中的“商户订单号”', 3);
            return;
        }

        dal.recoverMember(paymentId).then(res => {
            Toast.success('会员恢复成功，请重新下载并安装描述文件', 1);
            mapState()
        }).catch(errMsg => {
            Toast.fail('恢复会员失败:' + errMsg);
        })
    };

    const openTab = () => {
        let w: any = window.open('about:blank');
        w.location.href = AppConfig.domainsBookmarkPage
    }

    /**
     * 在home screen中打开应用，不显示添加到主屏幕
     */
    const renderAddToHomeButton = () => {
        if (isHomeScreenApp()) {
            return (
                <div></div>
            )
        } else {
            return (
                <div className={"sticky-footer"}>
                    <Button onClick={() => {
                        setModalVisible(true);
                    }}>添加到主屏幕</Button>
                </div>
            )
        }
    }

    return (
        <div className="App">
            <header className="App-header">
                <img src={headerBanner} className="header-banner" alt="logo"/>
            </header>
            <WhiteSpace size="lg"/>
            <WingBlank>
                {
                    user.recoverCode && <div className="card-tile">
                        <div style={{flex: 1}}>
                            <span style={{color: "red", fontSize: 16}}>
                                会员恢复码: {user.recoverCode}，请务必截图保存
                            </span>
                        </div>
                    </div>
                }

                <div className="card-tile">
                    <div style={{flex: 1, fontSize: 25}} className={"title"}>公告</div>
                    <div style={{flex: 3}}>
                        <a href={AppConfig.noticeUrl} target="_blank" style={{color: "black"}}>
                            {user.notice}
                        </a>
                    </div>
                </div>
                <div className="card-tile">
                    <div style={{flex: 3}}>
                        <span style={{fontSize: 20}} className={"title"}>首次使用</span>
                        <WhiteSpace size={"xs"}/>
                        <span>第一次使用请下载并安装描述文件</span>
                    </div>
                    <div style={{flex: 1}}>
                        <Link to={'/download-config'}>
                            <Button type="primary" size="small"
                                    style={{width: 85}}>立即下载</Button>
                        </Link>
                    </div>
                </div>
                <div className="card-tile">
                    <div style={{flex: 3}}>
                        <span style={{fontSize: 16}} className={"title"}>到期时间</span>&nbsp;&nbsp;
                        <span>{user.getVipEndTimeStr()}</span>
                        <WhiteSpace size={"xs"}/>
                        <span style={{fontSize: 16}} className={"title"}>剩余时间</span>&nbsp;&nbsp;
                        <span>{user.getVipLeftDays() + '天' + user.getVipLeftHours() + '小时' + user.getVipLeftMin() + '分钟'}</span>
                    </div>
                    <div style={{flex: 1}}>
                        <Link to={"/charge-plan"}>
                            <Button type="primary" size="small" style={{width: 85}}>充值</Button>
                        </Link>
                    </div>
                </div>
                <div className="card-tile">
                    <div style={{flex: 3}}>
                        <span style={{fontSize: 20}} className={"title"}>会员恢复</span>
                        <WhiteSpace size={"xs"}/>
                        <span>如果您更换手机，请点击会员恢复</span>
                    </div>
                    <div style={{flex: 1}}>
                        <Button type="primary" size="small" style={{width: 85}}
                                onClick={promptRecoverMemberDialog}>立即恢复</Button>
                    </div>
                </div>
                <div className="card-tile">
                    <div style={{flex: 3}}>
                        <span style={{fontSize: 20}} className={"title"}>备用域名</span>
                        <WhiteSpace size={"xs"}/>
                        <span>以下是我们的备用域名列表，请打开收藏</span>
                    </div>
                    <div style={{flex: 1}}>
                        <Button type="primary" size="small" style={{width: 85}} onClick={openTab}>备用域名</Button>
                    </div>
                </div>
                <WhiteSpace size="lg"/>
                <div className="card-tile">
                    <div style={{flex: 1}}>
                        <Link className={""} to={'/question-list'}>
                            <Button type="ghost">提问</Button>
                        </Link>
                    </div>
                </div>
                <WhiteSpace size="lg"/>
                <div className="card-tile"
                     style={{justifyContent: "center", paddingBottom: 0}}>
                    <div style={{fontSize: 16}} className={"title"}>成为会员后，请参考连接方法使用</div>
                </div>
                <div className="card-tile">
                    <div style={{flex: 1}}>
                        <Link className={""} to={'/connect-help'}>
                            <Button type="primary">连接方法</Button>
                        </Link>
                    </div>
                </div>
            </WingBlank>
            <div className={'white-item'}/>

            {renderAddToHomeButton()}

            <Modal
                style={{width: '90%', height: '70%'}}
                visible={modalVisible}
                transparent={true}
                maskClosable={true}
                onClose={() => {
                    setModalVisible(false);
                }}
            >
                <div>
                    <img style={{width: '100%'}} src={require('../images/addHome.png')}/>
                </div>
            </Modal>
            <ActivityIndicator toast text="正在加载" animating={animating}/>
        </div>
    );
}

export default Home;
